import React from "react";
import { StyleSheet, View } from "react-native";
import { useComponent, useHideSchedule } from "../providers/ConfigProvider";
import { MediaContentCarosel } from "../components/MediaContentCarosel";
import { TextCards } from "../components/TextCards";
import { PaginatedEvents } from "../components/PaginatedEvents";
import { TemplateProps } from "../../types";
import { BackgroundGradient } from "../components/BackgroundGradient";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";
import { BorderedContainer } from "../components/BorderedContainer";
import { Spacer } from "../components/ViewComponents";
import { TopBar } from "../components/TopBar";

const makeLayoutStyles = (theme: ThemeOptions) => {
  return StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: "column",
    },
    mainContent: {
      flex: 1,
      flexDirection: "column",
      paddingHorizontal: theme.spacing.regular,
      paddingBottom: theme.spacing.medium,
    },
  });
};

export const VerticalStacked = ({ onLoopComplete }: TemplateProps) => {
  const theme = useTheme();
  const styles = makeLayoutStyles(theme);
  const schedule = useComponent("schedule", "right_schedule");
  const media = useComponent("media", "media_content");
  const cards = useComponent("cards", "bottom_content_cards");
  const hideSchedule = useHideSchedule();

  return (
    <View style={styles.container}>
      <BackgroundGradient background={theme.background} accent={theme.accent} />
      <View style={styles.container}>
        <TopBar orientation="portrait" />
        <View style={styles.mainContent}>
          <BorderedContainer
            variant="secondary"
            style={{ flexGrow: 6, flexBasis: 0 }}
          >
            <MediaContentCarosel
              onLoopComplete={onLoopComplete}
              data={media ?? []}
            />
          </BorderedContainer>
          {!hideSchedule && (
            <>
              <Spacer size="small" />
              <BorderedContainer
                variant="secondary"
                style={{
                  flexGrow: 4,
                  flexBasis: 0,
                  paddingTop: theme.spacing.medium,
                }}
              >
                <PaginatedEvents
                  style={{ flexGrow: 5 }}
                  events={schedule?.events ?? []}
                  timeZone={schedule?.timeZone}
                  disableLoop={schedule?.disableLoop}
                  nextDayEvents={schedule?.nextDayEvents}
                />
              </BorderedContainer>
            </>
          )}
          {cards != null && cards.cards.length > 0 && (
            <BorderedContainer
              variant="secondary"
              style={{
                flexGrow: 2,
                flexBasis: 0,
                marginTop: theme.spacing.medium,
              }}
            >
              <TextCards data={cards} />
            </BorderedContainer>
          )}
        </View>
      </View>
    </View>
  );
};
